<div class="row justify-content-center mx-2 mt-4">
  @for (c of charts; track c.title) {
    @if (!c.when || c.when()) {
      <div class="mb-4" [class]="c.colClass">
        <app-common-chart
          [title]="c.title"
          [request]="c.request"
          [type]="c.type"
          [options]="c.options">
        </app-common-chart>
      </div>
    }
  }
</div>

<div class="w-100 row">
  <div class="mb-4 col-lg-12">
    <p-card>
      <p-header>
        <h5 class="p-3 mb-0">Actividad reciente</h5>
      </p-header>

      @for (activity of userActivitiesFormat; track activityTrackBy) {
        <div class="activity-container" [ngClass]="getActivityClass(activity.request_method)">
          <span>{{ activity.msg }}</span>
          <span class="text-secondary">{{ activity.fecha }}</span>
        </div>
      }
    </p-card>
  </div>
</div>

<a href="#" id="csvLink" style="visibility: hidden; position: fixed;"></a>
